<template>
  <div class="home" id="nsc" v-show="hasNSCs" v-if="kpi && kpi.SurveyWave">
    <table class="table">
      <tr>
        <th rowspan="2">NSC</th>
        <template v-for="wave in kpi.SurveyWave.slice(0, topRow)">
          <th class="right">{{ wave.Name }}</th>
          <td class="left">{{ wave.ResultNSC }}</td>
        </template>
      </tr>
      <tr class="left">
        <template v-for="wave in kpi.SurveyWave.slice(topRow)">
          <th class="right">{{ wave.Name }}</th>
          <td class="left">{{ wave.ResultNSC }}</td>
        </template>
      </tr>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'NarrowNscItem',
    data() {
      return {
      }
    },

    props:[
      'overallByWave',
      'hasBorder',
      'isInline',
      'isSmall',
      'kpi'
    ],

    methods: {
      hasWaves() {
        return this.kpi && this.kpi.SurveyWave && _.size(this.kpi.SurveyWave) > 0
      },
    },

    computed: {
      topRow: function () {
        return parseInt(this.waveCount / 2) + parseInt(this.waveCount % 2)
      },
      waveCount: function () {
        let _this = this
        if (!_this.hasWaves) return 0
        return _.size(_this.kpi.SurveyWave)
      },
      hasNSCs: function () {
        if (!this.kpi || !this.kpi.SurveyWave || _.size(this.kpi.SurveyWave) <= 0) return false
        return !_.find(this.kpi.SurveyWave, function(o) { return !o || !o.ResultNSC })
      }
    }
  }
</script>


<style scoped>

.left{
  border-left-width: 0px;
}
.right{
  border-right-width: 0px;
}
#nsc {
  position: relative;
  height: 26px;
  display: inline-block;
  line-height: 1.0
}
.home {
  overflow: hidden;
  max-height: 26px;
  display: inline-block;
  text-overflow: ellipsis;
  background: transparent;
}

table,
th,
tr,
td {
	border: 1px solid;
  border-color: #f5f5f5;
  padding: 0px;
}

.table {
  background: transparent;
  margin:0 auto;
  height: auto;
  max-width:100px;
  border-collapse: collapse;
}

td {
  font-size: 10px;
  text-align: center;
  padding: 1px;
  vertical-align:middle;
  letter-spacing: 0em;

}

th {
  font-size: 10px;
  letter-spacing: -0.05em;

  font-style: bold;
  text-align: center;
  vertical-align:middle;
  width: 20%;
}

tr {
  border-top-width: 1px;
  border-bottom-width: 0px;
  page-break-after:auto;
  page-break-inside:avoid;
  height:3.33mm;
  margin:1px;
  padding:1px;
  border:1px;
  page-break-inside:avoid;
  vertical-align:middle;
  text-align: center;
}

</style>
